module.exports = __webpack_public_path__ + "static/img/bg-tr.7eb14cf2.webp";